import { type FC } from "react";
import "./EventReports.scss";
import OpportunityReportTable from "../tables/opportunity-report-table";

export const EventReports: FC = () => {
    return <div className="event-reports-container">
        <OpportunityReportTable id="" />
    </div>;
};